export const DEPOSIT_WEBSITE_ID = 5;
export const INSPECTION_WEBSITE_ID = 19;